var map = {
	"./ClassBuds": [
		3442,
		442
	],
	"./ClassBuds/": [
		3442,
		442
	],
	"./ClassBuds/index": [
		3442,
		442
	],
	"./ClassBuds/index.tsx": [
		3442,
		442
	],
	"./DocViewer": [
		4690,
		499,
		690
	],
	"./DocViewer/": [
		4690,
		499,
		690
	],
	"./DocViewer/index": [
		4690,
		499,
		690
	],
	"./DocViewer/index.tsx": [
		4690,
		499,
		690
	],
	"./Home": [
		8404,
		404
	],
	"./Home/": [
		8404,
		404
	],
	"./Home/index": [
		8404,
		404
	],
	"./Home/index.tsx": [
		8404,
		404
	],
	"./Privacy": [
		9062,
		257,
		62
	],
	"./Privacy/": [
		9062,
		257,
		62
	],
	"./Privacy/index": [
		9062,
		257,
		62
	],
	"./Privacy/index.tsx": [
		9062,
		257,
		62
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;